import React from 'react';
import { Colors } from '../../constants';

const PrevIcon = ({ handleOnClick, color = `#${Colors.blackText}` }) => {
  return(
    <button className="icon" onClick={() => handleOnClick()} >
      <svg width="40" height="40" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
        <rect x="10" y="6" width="124" height="124" rx="62" fill="white"/>
        </g>
        <path 
          d="M93.6988 68H50.2988" 
          stroke={color}
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"/>
        <path 
          d="M71.9988 89.7008L50.2988 68.0008L71.9988 46.3008" 
          stroke={color}
          strokeWidth="8" 
          strokeLinecap="round"
          strokeLinejoin="round"/>
        <defs>
        <filter id="filter0_d" x="0" y="0" width="144" height="144" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        </defs>
    </svg>
    </button>
  )
};

export default PrevIcon;